import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { WorkExperience } from '../entities/work-experience';

@Injectable()
export class WorkExperienceService extends BaseCrudService<WorkExperience> {

    public uri = '/api/workExperience/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance WorkExperienceService');
    }

    buildSentence(entity?: WorkExperience, event?: LazyLoadEvent): HttpParams {
     //console.log("en el buiildSentence : ", entity);
        if (entity) {
          let query = '';
          query = query.concat(
            entity.row ?
              `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.startDate ?
              `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.endDate ?
              `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.issueDate ?
              `issueDate${QueryOperator.Equal}${entity.issueDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.comment ?
              `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
         //console.log("antes del entity.employee");
         //console.log("query :" , query);
          if (entity.employee) {
           //console.log("entro al  if: " , entity.employee.id)
            query = query.concat(
              `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
            );
          }
         //console.log("despues del entity.employee");
         //console.log("query :" , query);
          if (entity.previousWorkplace && entity.previousWorkplace.id) {
            query = query.concat(
              `previousWorkplace.id${QueryOperator.Equal}${entity.previousWorkplace.id}${QueryOperator.Split}`
            );
          }
          if (entity.previousJobTitle && entity.previousJobTitle.id) {
            query = query.concat(
              `previousJobTitle.id${QueryOperator.Equal}${entity.previousJobTitle.id}${QueryOperator.Split}`
            );
          }
          if (entity.supportingDocument && entity.supportingDocument.id) {
            query = query.concat(
              `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
            );
          }

         //console.log("query : " , query);
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }
       //console.log("httpParams : " , this.httpParams);
        if (event) {
          const page = ((event.first + event.rows) / event.rows - 1).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
       //console.log("httpParams : " , this.httpParams);
        return this.httpParams;
      }
}



// WEBPACK FOOTER //
// ./src/app/core/services/work-experience.service.ts